import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux"; 
import store from "./redux/store"; 
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import axios from 'axios';
import reportWebVitals from './reportWebVitals';
import Description from './components/atoms/description';
import FormSearch from './components/molecules/formSearch';
import ResultsTable from './components/molecules/resultsTable';
import MapEarthquake from './components/molecules/mapEarthquake'
import Waveforms from './components/molecules/waveforms';
import Sfiles from './components/molecules/sfiles';
import ResponseFiles from './components/molecules/responseFiles';
import WaveformsStation from './components/molecules/waveformsStation';
import Mapa from './components/molecules/map'
import MapStation from './components/molecules/mapStations'
import Swal from "sweetalert2";

const root = ReactDOM.createRoot(document.getElementById('root'));


const App = () => {
	const [results, setResults] = useState([]);
	const navigate = useNavigate();

	async function _onAction(action, formData) {
	  try {
	    // Mostrar mensaje de carga
	    Swal.fire({
	      title: "Consultando datos...",
	      text: "Por favor espera mientras se realiza la búsqueda.",
	      allowOutsideClick: false,
	      didOpen: () => {
	        Swal.showLoading();
	      },
	    });
	
	    // Petición al backend
	    const response = await axios.post(
	      `${process.env.REACT_APP_API_URL}/search`,
	      formData
	    );
	
	    // Cerrar el mensaje de carga
	    Swal.close();
	
	    // Validar si hay resultados
	    if (response.data && response.data.results && response.data.results.length > 0) {
	      setResults(response.data);
	      navigate("/resultados");
	    } else {
	      Swal.fire({
	        title: "Sin resultados",
	        text: "No se encontraron registros con los criterios ingresados.",
	        icon: "info",
	        confirmButtonText: "Aceptar",
	        confirmButtonColor: "#3085d6",
	      });
	    }
	
	  } catch (error) {
	    console.error("Error en la búsqueda:", error);
	
	    // Cerrar el loading si ocurre un error
	    Swal.close();
	
	    Swal.fire({
	      title: "Error en la búsqueda",
	      text: "Ocurrió un problema al consultar los datos. Por favor, intenta nuevamente.",
	      icon: "error",
	      confirmButtonText: "Cerrar",
	      confirmButtonColor: "#d33",
	    });
	  }
	}

	return (
		<Routes>
			<Route
				path="/"
				element={
					<>
						<Description />
						<FormSearch onAction={_onAction} />
					</>
				}
			/>

			<Route path="/resultados" element={<ResultsTable data={results} />} />
			<Route path="/mapa" element={<Mapa />} />
			<Route path="/mapa-sismicidad" element={<MapEarthquake />} />
			<Route path="/formas-onda" element={<Waveforms />} />
			<Route path="/sfiles" element={<Sfiles />} />
			<Route path="/responseFiles" element={<ResponseFiles />} />
			<Route path="/waveformsStation" element={<WaveformsStation />} />
			<Route path="/map-stations" element={<MapStation />} />
		</Routes>
	);
};

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<Router>
				<App />
			</Router>
		</Provider>
		{/* <App /> */}

	</React.StrictMode>
);

reportWebVitals();
